import React, { useEffect, useState } from 'react';
import { getAuthorizationBearer } from '../../api/endpoint';
import { Loading } from 'lqx-react/lib';

export const JpgViewer = ({ url, $zoomLevel, $loaded }: { url: string, $zoomLevel, $loaded }) => {
    const [jpgUrlContent, setjpgUrlContent] = useState('');

    useEffect(() => {
        const fetchJpgContent = async () => {
            try {
                const response = await fetch(url, {
                    headers: {
                        'Authorization': getAuthorizationBearer(),
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.blob();
                const urlFile = URL.createObjectURL(data);
                setjpgUrlContent(urlFile);
                $loaded.set(true);
            } catch (error) {
                console.error('Error fetching HTML:', error);
            }
        };
        fetchJpgContent();
    }, []);

    return (
        $loaded.value
            ?
            <img
                src={jpgUrlContent}
                alt="Rendered Image"
                style={{ transform: `scale(${$zoomLevel.value})`, transformOrigin: '0 0' }}
            />
            : <Loading />
    );
}

